<template>
    <div>
        <PageHeader>
            {{ $t('campaignsList') }}
            <template #side>
                <ButtonIcon @click="addCampaign()">{{ $t('addCampaign') }}</ButtonIcon>
            </template>
        </PageHeader>
        <Filters ref="Filters" />
        <Results ref="Results" />
        <ModalAddCampaign />
    </div>
</template>



<script>
    import viewFiltersMixin from '@/mixins/viewFiltersMixin';
    import Filters from './parts/Filters.vue';
    import Results from './parts/Results.vue';
    import ModalAddCampaign from './parts/ModalAddCampaign.vue';

    const DEFAULT_FILTERS_PARAMS = Object.freeze({
        name: null,
        id: null,
        advertiser: null,
        categories: [],
        active: true,
        hidden: false,
    });
    const DEFAULT_TABLE_PARAMS = Object.freeze({
        perPage: 25,
        page: 1,
        sort: 'id',
        order: 'DESC',
    });

    export default {
        name: 'AdminCampaignsList',
        mixins: [viewFiltersMixin],
        components: {
            Filters,
            Results,
            ModalAddCampaign,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                ...this.initParams(DEFAULT_FILTERS_PARAMS, DEFAULT_TABLE_PARAMS),
                request: this.$req('campaigns/campaigns'),
            };
        },
        methods: {
            addCampaign() {
                this.$root.$emit('bv::show::modal', 'modal-form-campaigns-advertiser-campaigns');
            },
        },
    };
</script>
